import React from 'react';
import styled from 'styled-components';
import logo from "../../../../../../assets/images/logo.png";   

const LogoBox = styled.div`
  margin-bottom: 25px;
`;

const LogoImg = styled.img`
  width: 93.73px;
  height: 24.12px;
`;

const LogoSpan = styled.span`
  font-weight: 500;
  font-size: 14px;
  margin-left: 8.43px;
`;

function LogoComponent() {
  return (
    <LogoBox>
      <LogoImg src={logo} alt={"logo"} />
      <LogoSpan>{"플리더스"}</LogoSpan>
    </LogoBox>
  );
}

export default LogoComponent; 